angular
	.module('AutoPrequal')
	.controller('tradeinPaymentsCtrl', tradeinPaymentsCtrl);

tradeinPaymentsCtrl.$inject = ['$scope', '$rootScope', 'ScrollFactory', 'DataFactory'];

function tradeinPaymentsCtrl($scope, $rootScope, ScrollFactory, DataFactory) {

	$rootScope.progressCurrent = 14;
	$rootScope.progressMobCurrent = 14;

	$scope.content = DataFactory.appData.content;
	$scope.localContent = DataFactory.appData.content.tradeinPayments;

	$scope.data = DataFactory.appData.applicant;
	$scope.sendGAEvent = sendGAEvent;

	$rootScope.tradeinPaymentsNextStep = function () {
		if ($scope.TradeinPayments.$valid) {

			if ($scope.data.apMakingPayments === $scope.localContent.option_2_val) {
				$scope.data.apBalance = 0;
				$scope.data.apTradeinValue = 0;
			}
			else if ($scope.data.apMakingPayments === $scope.localContent.option_3_val) {
				$scope.data.apBalance = 0;
			}

			sendGAEvent();

			DataFactory.appData.applicant.appState.tradeinPayments = true;

			DataFactory.setData($scope.data);

			ScrollFactory.showStep("downPayment");
			ScrollFactory.goToStep("downPayment");
			return true;
		}
		else {
			angular.forEach($scope.TradeinPayments.$error, function (field) {
				angular.forEach(field, function (errorField, index) {
					errorField.$setTouched();
					$rootScope.ga.validationErr(errorField.$name);
					$rootScope.errorNumber = index + 1;
				})
			});
		}
	}

	$scope.prevStep = function () {
		if ($rootScope.tradeinHelp) {
			ScrollFactory.showStep("tradeinEstimate");
			ScrollFactory.goToStep("tradeinEstimate");
		}
		else {
			ScrollFactory.showStep("tradeinHelp");
			ScrollFactory.goToStep("tradeinHelp");
		}
	}

	function sendGAEvent() {
		switch ($scope.data.apMakingPayments) {
			case $scope.localContent.option_1_val:
				$rootScope.ga.makingPaymentsYes();
				break;
			case $scope.localContent.option_2_val:
				$rootScope.ga.makingPaymentsUnsure();
				break;
			case $scope.localContent.option_3_val:
				$rootScope.ga.makingPaymentsNo();
				break;
			default:
				return;
		}
	}
}
